module.exports = __webpack_public_path__ + "static/vsfactory-d97679de040257fd87c0fdd896c81574.png";